import { useAccountStatus } from "@/hooks/use-account-status";
import { useIsAdmin } from "@/hooks/use-is-admin";

/**
 * Whether the signed-in user may see community data. Brands are in the app from day one, but only
 * approved brands (and admins) see communities. This is a screen gate; the database is the real lock.
 */
export function useCommunityAccess() {
  const { status, loading: statusLoading } = useAccountStatus();
  const { data: isAdmin, isPending: adminPending } = useIsAdmin();
  const loading = statusLoading || adminPending;
  // A failed status lookup leaves status null: do not lock an approved brand out because of an error.
  const allowed = !!isAdmin || status === "accepted" || status === null;
  return { allowed, loading, status };
}
